/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Bottom_Center_TitleInputs */



/**
* | output |
* | --- |
* | "Position: Bottom Center" |
*
* @param {Position_Bottom_Center_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_bottom_center_title = /** @type {((inputs?: Position_Bottom_Center_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Bottom_Center_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position : En Bas au Centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position: Unten Mitte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione: in basso al centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция: Нижний центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición: Centro inferior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置：底部中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置: 下中央")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति: नीचे केंद्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição: Centro inferior")
	return /** @type {LocalizedString} */ ("Position: Bottom Center")
});